<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="home"></ion-back-button>
    </ion-buttons>
    <ion-title>Weekly Recommendations</ion-title>
    <ion-buttons slot="end"> </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div *mobxAutorun>
    <div *ngIf="postStore.weeklyPosts.length == 0">
      <ion-progress-bar type="indeterminate" color="primary"></ion-progress-bar>
    </div>
    <cdk-virtual-scroll-viewport [itemSize]="100" minBufferPx="500" maxBufferPx="1000">
      <div *ngFor="let post of postStore.weeklyPosts">
        <post-card [post]="post"></post-card>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</ion-content>
